// Packages
import React, { useState } from 'react';
import { connect, useDispatch } from "react-redux";
import { useLocation, Navigate } from 'react-router-dom';
import {Header, Grid, Container, Message} from 'semantic-ui-react';
import {persistConfig} from "../../../store";

// Auth
import * as authActions from "../../../auth/AuthActions"

function MarvelLoginPage(props) {
    const dispatch = useDispatch()
    let location = useLocation();

    // Local state — NOT in Redux so never persists after refresh
    const [loginError, setLoginError] = useState(null); // null | 'no-role' | 'error'

    async function handleLoginClick() {
        setLoginError(null);
        const result = await dispatch(authActions.signIn());
        if (!result.success) {
            setLoginError(result.reason);
        }
    }

    return (
        <>
            {props.authorized ?
                <Navigate to="/home" state={{ from: location }} />
                :
                <div className="login-page-container" style={{ paddingTop: '20vh' }}>
                    <Container>
                        <Grid centered relaxed padded>
                            <Grid.Row style={{paddingBottom: 0}}>
                                <Header
                                    as='h1'
                                    content='MARVEL'
                                    style={{
                                        fontSize: '6em'
                                    }}
                                />
                            </Grid.Row>
                            <Grid.Row style={{padding: 0}}>
                                <Header
                                    as='h3'
                                    content={"v" + persistConfig.version}
                                    style={{
                                        fontSize: '2em'
                                    }}
                                />
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column centered="true" width={4}>
                                    <button
                                        onClick={handleLoginClick}
                                        style={{
                                            alignItems: 'center',
                                            background: '#2F2F2F',
                                            border: 'none',
                                            color: '#FFFFFF',
                                            display: 'flex',
                                            fontFamily: 'Segoe UI, SegoeUI, Helvetica Neue, Helvetica, Arial, sans-serif',
                                            fontSize: '15px',
                                            height: '41px',
                                            padding: '0 18px 0 12px'
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" style={{ marginRight: '12px' }}><title>MS-SymbolLockup</title><rect x="1" y="1" width="9" height="9" fill="#f25022" /><rect x="1" y="11" width="9" height="9" fill="#00a4ef" /><rect x="11" y="1" width="9" height="9" fill="#7fba00" /><rect x="11" y="11" width="9" height="9" fill="#ffb900" /></svg>
                                        Sign in with Microsoft
                                    </button>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Message info content={"Please login with your LSEG credentials."} />
                            </Grid.Row>
                            <div aria-live="polite" aria-atomic="true">
                                {loginError === 'no-role' && (
                                    <Grid.Row>
                                        <Message error content={"You do not have the required role to access this application. Please contact your administrator."} />
                                    </Grid.Row>
                                )}
                                {loginError === 'error' && (
                                    <Grid.Row>
                                        <Message error content={"An error occurred during sign in. Please try again or contact your administrator."} />
                                    </Grid.Row>
                                )}
                            </div>
                        </Grid>
                    </Container>
                </div>
            }
        </>
    )
}



const mapStateToProps = (state) => ({
    authorized: state.marvel.user.authorized,
});

const mapDispatchToProps = dispatch => ({
    interactiveLogin: () => { dispatch(authActions.signIn()) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MarvelLoginPage)
